import request from '@/utils/request'
import { MLMCore } from "@/utils/requestApi";
const qs = require('qs')

export function membershipOptions() {
  return request({
    url: MLMCore() + "/membership/membership_options",
    method: "GET",
  });
}

export function upgradeMembershipValidate(data) {
  return request({
    url: MLMCore() + '/membership/upgrade_validation',
    method: 'POST',
    data: qs.stringify(data) // untuk array data post
  })
}

export function upgradeMembershipStored(data) {
  return request({
    url: MLMCore() + '/membership/upgrade_stored',
    method: 'POST',
    data: qs.stringify(data) // untuk array data post
  })
}


// WEBPACK FOOTER //
// ./src/api/upgradeMember.js